import { render, staticRenderFns } from "./OldOperationHistoryTable.vue?vue&type=template&id=259c36ab"
import script from "./OldOperationHistoryTable.vue?vue&type=script&lang=ts"
export * from "./OldOperationHistoryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports